import { Box, Typography } from '@mui/material';
import { InfoIcon } from '../icons';

interface InfoCalloutProps {
  title: string;
  body: string;
}

export default function InfoCallout({ title, body }: InfoCalloutProps) {
  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        gap: 1.5,
        p: 2,
        borderRadius: `${theme.shape.borderRadius}px`,
        backgroundColor: theme.app.infoSurface,
      })}
    >
      <Box sx={(theme) => ({ color: theme.app.link, flexShrink: 0, mt: '2px' })}>
        <InfoIcon size={18} />
      </Box>
      <Box>
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          {title}
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {body}
        </Typography>
      </Box>
    </Box>
  );
}
